import { Action } from "redux";
import { isType } from "typescript-fsa";
import { upsertMultipleValuesInArray } from "../../../utilities/helpers/reducer-helpers";
import * as actions from "./actions";
import { NotificationState } from "./types";

const initialState: NotificationState = {
  notifications: [],
  pending: false,
  notificationDrawerVisible: false,
  notificationRetrivalFailed: false,
  emptyNotificationList: false,
};

export const notificationReducer = (
  state = initialState,
  action: Action
): NotificationState => {
  if (isType(action, actions.notificationContentAction.started)) {
    return {
      ...state,
      pending: true,
      notificationRetrivalFailed: false,
      emptyNotificationList: false,
    };
  }
  if (isType(action, actions.notificationContentAction.done)) {
    if (action.payload.result.length < 1) {
      return {
        ...state,
        pending: false,
        notificationRetrivalFailed: false,
        emptyNotificationList: true,
      };
    } else
      return {
        ...state,
        notifications: upsertMultipleValuesInArray(
          state.notifications,
          action.payload.result
        ),
        pending: false,
        notificationRetrivalFailed: false,
      };
  }

  if (isType(action, actions.notificationContentAction.failed)) {
    return {
      ...state,
      pending: false,
      notificationRetrivalFailed: true,
    };
  }

  if (isType(action, actions.showNotificationDrawerAction)) {
    return {
      ...state,
      notificationDrawerVisible: state.notificationDrawerVisible ? false : true,
    };
  }

  return state;
};
